export default __webpack_public_path__ + "static/media/aispeak_section3.59445938.png";